import instance from "../utils/network";
import { SellerPubMissionResetRequest } from "./pub-mission";

export enum MissionBingoColumnType {
  CUMULATIVE = "CUMULATIVE",
  ONE_OFF = "ONE_OFF",
}

export enum MissionBingoRowRewardDetailType {
  POINT = "POINT",
  OTHER = "OTHER",
}

export enum SellerBingoSizeFilter {
  ALL = "ALL",
  THREE = "3",
  FOUR = "4",
}

export enum SellerPubMissionBingoStatusFilter {
  ALL = "ALL",
  IN_PROGRESS = "IN_PROGRESS",
  ENDED = "ENDED",
}

export enum SellerPubMissionBingoStatus {
  WAITING = "WAITING",
  IN_PROGRESS = "IN_PROGRESS",
  ENDED = "ENDED",
}

export interface SellerPubMissionBingoListRequest {
  pubId: number;
  page: number;
  limit: number;
  name?: string;
  size?: SellerBingoSizeFilter;
  status?: SellerPubMissionBingoStatusFilter;
}

export interface SellerBingoCellRequest {
  row: number;
  column: number;
  name: string;
  type: MissionBingoColumnType;
  count?: number;
}

export interface SellerBingoStageRewardRequest {
  type: MissionBingoRowRewardDetailType;
  count?: number;
  name?: string;
}

export interface SellerBingoStageRequest {
  row: number;
  rewards: SellerBingoStageRewardRequest[];
}

export interface SellerPubMissionBingoRequest {
  pubId: number;
  name: string;
  startDate: Date | string;
  endDate: Date | string;
  column: number;
  cells: SellerBingoCellRequest[];
  stages: SellerBingoStageRequest[];
}

export interface SellerPubMissionBingoListItemResponse {
  id: number;
  name: string;
  column: number;
  sizeLabel: string;
  periodLabel: string;
  rewardStageCount: number;
  rewardStageLabel: string;
  createdAt: string;
  status: SellerPubMissionBingoStatus;
  statusLabel: string;
  isEnd: boolean;
  canDelete: boolean;
}

export interface SellerPubMissionBingoListResponse {
  total: number;
  list: SellerPubMissionBingoListItemResponse[];
}

export interface SellerBingoCellResponse {
  id: number;
  row: number;
  column: number;
  name: string;
  type: MissionBingoColumnType;
  count?: number;
}

export interface SellerBingoStageRewardResponse {
  id: number;
  type: MissionBingoRowRewardDetailType;
  count?: number;
  name?: string;
}

export interface SellerBingoStageResponse {
  id: number;
  row: number;
  rewards: SellerBingoStageRewardResponse[];
}

export interface SellerPubMissionBingoDetailResponse {
  id: number;
  pubId: number;
  name: string;
  startDate: string;
  endDate: string;
  column: number;
  isEnd: boolean;
  cells: SellerBingoCellResponse[];
  stages: SellerBingoStageResponse[];
  canEdit: boolean;
}

export function getPubMissionBingoList(
  request: SellerPubMissionBingoListRequest,
): Promise<SellerPubMissionBingoListResponse> {
  return instance.get("/seller/pub-mission-bingo", { params: request });
}

export function getPubMissionBingoDetail(
  id: number,
  pubId: number,
): Promise<SellerPubMissionBingoDetailResponse> {
  return instance.get(`/seller/pub-mission-bingo/${id}`, { params: { pubId } });
}

export function createPubMissionBingo(
  request: SellerPubMissionBingoRequest,
): Promise<{ code: number; message: string }> {
  return instance.post("/seller/pub-mission-bingo", request);
}

export function updatePubMissionBingo(
  id: number,
  request: SellerPubMissionBingoRequest,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub-mission-bingo/${id}`, request);
}

export function endPubMissionBingo(
  id: number,
  pubId: number,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub-mission-bingo/${id}/end`, null, {
    params: { pubId },
  });
}

export function resetPubMissionBingoProgress(
  id: number,
  pubId: number,
  request?: SellerPubMissionResetRequest,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub-mission-bingo/${id}/reset`, request ?? {}, {
    params: { pubId },
  });
}

export function deletePubMissionBingo(
  id: number,
  pubId: number,
): Promise<{ code: number; message: string }> {
  return instance.delete(`/seller/pub-mission-bingo/${id}`, {
    params: { pubId },
  });
}
